export default __webpack_public_path__ + "static/media/tupay-channels.f1afc893.png";